export interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'quanbu', name: '全部', icon: 'ri-movie-line', count: 12 },
  { id: 'dongzuopian', name: '动作片', icon: 'ri-boxing-line', count: 1 },
  { id: 'xijupian', name: '喜剧片', icon: 'ri-emotion-laugh-line', count: 1 },
  { id: 'aiqingpian', name: '爱情片', icon: 'ri-heart-line', count: 1 },
  { id: 'kehuanpian', name: '科幻片', icon: 'ri-rocket-line', count: 2 },
  { id: 'kongbupian', name: '恐怖片', icon: 'ri-ghost-line', count: 1 },
  { id: 'xuanyipian', name: '悬疑片', icon: 'ri-search-eye-line', count: 1 },
  { id: 'donghuapian', name: '动画片', icon: 'ri-bear-smile-line', count: 1 },
  { id: 'jilupian', name: '纪录片', icon: 'ri-camera-lens-line', count: 1 },
  { id: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', count: 4 },
];